<template>
  <v-container>
    <EditorExistingComments />
    <EditorNewComment :assignment="assignment" />
  </v-container>
</template>

<script>
// vuex
import { mapActions } from "vuex";
// components
import EditorNewComment from "./EditorNewComment.vue";
import EditorExistingComments from "./EditorExistingComments.vue";

export default {
  name: "EditorCommentsView",
  props: {
    assignment: {
      type: Object,
      required: true,
    },
  },
  components: {
    EditorNewComment,
    EditorExistingComments,
  },
  methods: {
    ...mapActions("editor", ["setAssignmentComments"]),
  },
};
</script>

<style lang="scss" scoped></style>
